import { plainToInstanceWithLVS } from '@goparrot/common';
import { BaseCampaignFacade } from '../../common';
import { ConfigTemplateDto, ReadTemplateDto } from '../generated-dto';
import { TemplateExposeGroup } from '../interface';
export class TemplateFacade extends BaseCampaignFacade {
    async getList(merchantId) {
        return plainToInstanceWithLVS(ReadTemplateDto, (await this.client.get(`api/v2/merchants/${merchantId}/campaign-templates`)).data, {
            groups: [TemplateExposeGroup.READ],
        });
    }
    async get(merchantId, id) {
        return plainToInstanceWithLVS(ReadTemplateDto, (await this.client.get(`api/v2/merchants/${merchantId}/campaign-templates/${id}`)).data, {
            groups: [TemplateExposeGroup.READ],
        });
    }
    async getConfig(merchantId, id) {
        return plainToInstanceWithLVS(ConfigTemplateDto, (await this.client.get(`api/v2/merchants/${merchantId}/campaign-templates/${id}/config`)).data, {
            groups: [TemplateExposeGroup.CONFIG],
        });
    }
}
//# sourceMappingURL=TemplateFacade.js.map